import { useIsMobile } from '@/hooks/use-is-mobile';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
const HomeVideo = props => {
  const { isMobile } = useIsMobile();
  const { video } = props;
  const videoRef = useRef(null);
  const hideControlsTimeout = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  // 根据设备类型选择视频和封面
  let videoUrl = isMobile ? video?.m_video : video?.p_video;
  let posterUrl = isMobile ? video?.m_pic : video?.p_pic;

  // // hh todo
  if (videoUrl?.indexOf('cms')) {
    videoUrl = videoUrl.replace('cms', 'Cms');
    posterUrl = posterUrl.replace('cms', 'Cms');
  }

  // hh todo
  if (videoUrl?.indexOf('http://192.168.0.99:11111/') >= 0) {
    videoUrl = videoUrl.replace('http://192.168.0.99:11111/', 'http://192.168.0.99/hisea244/');
    posterUrl = posterUrl.replace('http://192.168.0.99:11111/', 'http://192.168.0.99/hisea244/');
  }

  // console.log("NODE_ENV", process.env.NODE_ENV)
  // console.log('video', video, videoUrl, process.env.NEXT_PUBLIC_MAGENTO_BACKEND_URL);

  // 重置控件隐藏计时器
  const resetControlsTimer = () => {
    setShowControls(true);
    clearTimeout(hideControlsTimeout.current);
    hideControlsTimeout.current = setTimeout(() => {
      setShowControls(false);
    }, 3000);
  };

  // 同步实际静音状态
  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    setIsMuted(videoRef.current.muted);
  }, [videoRef.current?.muted]);

  // 切换静音状态
  const toggleMute = () => {
    if (!videoRef.current) {
      return;
    }

    videoRef.current.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  // 切换播放状态
  const togglePlay = () => {
    if (!videoRef.current) {
      return;
    }

    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }

    setIsPlaying(!isPlaying);
    resetControlsTimer();
  };

  // 处理视频加载完成
  const [videoHeight, setVideoHeight] = useState(0);

  const handleCanPlay = () => {
    setIsVideoLoaded(true);
    videoRef.current
      .play()
      .then(() => {
        setIsPlaying(true);
        //   resetControlsTimer();
      })
      .catch(error => {
        console.error('自动播放失败:', error);
      });
  };

  // 初始化组件
  useEffect(() => {
    if (!videoUrl) {
      return;
    }

    const videoElement = videoRef.current;

    if (videoElement) {
      videoElement.addEventListener('canplay', handleCanPlay);
    }

    return () => {
      clearTimeout(hideControlsTimeout.current);

      if (videoElement) {
        videoElement.removeEventListener('canplay', handleCanPlay);
      }
    };
  }, [video, videoUrl]);

  const [isHovered, setIsHovered] = useState(false);
  // 添加屏幕高度状态
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [shopBtnBottom, setShopBtnBottom] = useState(0);
  const [playBtnBottom, setPlayBtnBottom] = useState(0);

  // 使用 ResizeObserver 监听视频元素的实际渲染高度
  useEffect(() => {
    console.log('videoRef', videoRef);

    if (!videoRef.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        // 获取视频元素的实际渲染高度
        const height = entry.contentRect.height;

        if (height > 0) {
          setVideoHeight(height);
        }
      }
    });

    resizeObserver.observe(videoRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [video]);
  useEffect(() => {
    // console.log("windowHeight", windowHeight, videoHeight)

    if (windowHeight < videoHeight) {
      setShopBtnBottom(windowHeight - 68 - 40);
      setPlayBtnBottom(windowHeight / 2 - 20);
    } else {
      setShopBtnBottom(videoHeight - 64);
      setPlayBtnBottom(videoHeight / 2);
    }
  }, [windowHeight, videoHeight]);
  // const shopBtnBottom = windowHeight - 68 - 40;
  // const playBtnBottom = windowHeight / 2 - 20;

  // 添加监听窗口大小变化的 effect
  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 加载状态显示Logo
  if (!videoUrl) {
    if (posterUrl) {
      return (
        <Image
          className='w-full'
          src={posterUrl}
          alt=''
          width='1920'
          height='800'
          quality={100}
        />
      );
    }
    return <div className='flex h-screen w-full items-center justify-center bg-secondary'></div>;
  }

  return (
    <div
      className='relative w-full'
      style={{ aspectRatio: '1920 / 800' }}
      onMouseEnter={resetControlsTimer}
      onMouseMove={resetControlsTimer}
      onMouseLeave={() => {
        clearTimeout(hideControlsTimeout.current);
        hideControlsTimeout.current = setTimeout(() => {
          setShowControls(false);
        }, 3000);
      }}
    >
      {/* 封面图片 - 视频加载前显示 */}
      {!isVideoLoaded && (
        <img
          src={posterUrl}
          alt='视频封面'
          width={1920}
          height={800}
          className='absolute inset-0 h-full w-full object-cover'
          loading='eager'
          fetchPriority='high'
        />
      )}
      {/* 静音按钮 */}
      {isVideoLoaded && (
        <div className='absolute bottom-[48px] right-[20px] z-10 lg_right-[80px]'>
          <button
            type='button'
            onClick={toggleMute}
            aria-label={isMuted ? 'Unmute' : 'Mute'}
            className='p-2 opacity-70 transition'
          >
            {isMuted ? (
              <Image
                width={32}
                height={32}
                src='/home/voice-off.svg'
                alt='unmute'
              />
            ) : (
              <Image
                width={32}
                height={32}
                src='/home/voice-on.svg'
                alt='unmute'
              />
            )}
          </button>
        </div>
      )}
      {/* 视频元素 */}
      <Link href={video.link}>
        <video
          ref={videoRef}
          src={videoUrl}
          poster={posterUrl}
          muted={isMuted}
          playsInline
          autoPlay
          loop
          className=' inset-0 h-full w-full object-contain'
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onEnded={() => setIsPlaying(false)}
        />
      </Link>

      {/* 视频控制按钮 */}
      <div
        className={`duration-300 absolute inset-x-0 flex -translate-y-1/2 items-center justify-center transition-opacity ${
          showControls ? 'hidden opacity-100' : 'hidden opacity-0'
        }`}
        style={{
          top: playBtnBottom,
        }}
        onClick={e => e.stopPropagation()}
      >
        <button
          className='rounded-full p-3 transition-transform hover_scale-105 md_p-4'
          onClick={togglePlay}
          aria-label={isPlaying ? 'parse' : 'play'}
        >
          {isPlaying ? (
            <svg
              width='64'
              height='64'
              viewBox='0 0 64 64'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M62.5 32C62.5 48.8447 48.8447 62.5 32 62.5C15.1553 62.5 1.5 48.8447 1.5 32C1.5 15.1553 15.1553 1.5 32 1.5C48.8447 1.5 62.5 15.1553 62.5 32Z'
                stroke='#FCFAF7'
                strokeWidth='3'
              />
              <path
                d='M23 18L23 46'
                stroke='#FCFAF7'
                strokeWidth='5'
                strokeLinecap='round'
              />
              <path
                d='M41 18L41 46'
                stroke='#FCFAF7'
                strokeWidth='5'
                strokeLinecap='round'
              />
            </svg>
          ) : (
            <svg
              width='64'
              height='64'
              viewBox='0 0 64 64'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M62.5 32C62.5 48.8447 48.8447 62.5 32 62.5C15.1553 62.5 1.5 48.8447 1.5 32C1.5 15.1553 15.1553 1.5 32 1.5C48.8447 1.5 62.5 15.1553 62.5 32Z'
                stroke='#FCFAF7'
                strokeWidth='3'
              />
              <path
                d='M45 30.2679C46.3333 31.0378 46.3333 32.9623 45 33.7321L27 44.1244C25.6667 44.8942 24 43.9319 24 42.3923L24 21.6077C24 20.0681 25.6667 19.1058 27 19.8756L45 30.2679Z'
                fill='#FCFAF7'
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default HomeVideo;
